export default "__VITE_ASSET__BuYGiTP7__"